import {
    CommonSearchParamInUrlEnum,
    IParkBindTableNameEnum,
} from "@reco-w/common-common";
import { SearchParamInUrlEnum as FavouriteSearchParamInUrlEnum } from "@reco-w/favorites-models";
import { MySettingTabEnum } from "@reco-w/my-models";

/**
 * 与我相关 的目录
 * @returns
 */
function getMyMenuRelatedToMe() {
    return [
        {
            key: "/my/myserve",
            url: `/my/myserve?c=QB`,
            icon: "iconjilu",
            title: "服务记录",
        },
        {
            key: "/my/myactivity",
            url: `/my/myactivity`,
            icon: "iconhuodong",
            title: "我的活动",
        },
        {
            key: "/my/myfavorte",
            url: `/my/myfavorte?${FavouriteSearchParamInUrlEnum.chosenFavourite}=${IParkBindTableNameEnum.activity}`,
            icon: "iconshoucang",
            title: "我的收藏",
        },
    ];
}


/**
 * 我的 目录
 * @returns
 */
export function getMyMenu() {
    return [
        {
            key: "/my",
            url: `/my`,
            icon: "iconhome-g",
            title: "我的主页",
        },
        {
            key: "/my/mynotice",
            url: `/my/mynotice`,
            icon: "iconxiaoxi",
            title: "消息中心",
            badgeMap: "noticeCount",
        },
        {
            key: "/my/relatedToMe",
            icon: "iconcorrelation",
            title: "与我相关",
            children: getMyMenuRelatedToMe(),
        },
        {
            key: "/my/mysetting",
            url: `/my/mysetting?${CommonSearchParamInUrlEnum.titleTab}=${MySettingTabEnum.user}`,
            icon: "iconshezhi",
            title: "账号设置",
        },
    ];
}
